import tailChase from '../elements/tailChase.js';
tailChase.register();
